export const DashboardIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.75 10.2334V14.7334M9.5 12.4834H14M3.5 7.2334H5C5.82843 7.2334 6.5 6.56183 6.5 5.7334V4.2334C6.5 3.40497 5.82843 2.7334 5 2.7334H3.5C2.67157 2.7334 2 3.40497 2 4.2334V5.7334C2 6.56183 2.67157 7.2334 3.5 7.2334ZM11 7.2334H12.5C13.3284 7.2334 14 6.56183 14 5.7334V4.2334C14 3.40497 13.3284 2.7334 12.5 2.7334H11C10.1716 2.7334 9.5 3.40497 9.5 4.2334V5.7334C9.5 6.56183 10.1716 7.2334 11 7.2334ZM3.5 14.7334H5C5.82843 14.7334 6.5 14.0618 6.5 13.2334V11.7334C6.5 10.905 5.82843 10.2334 5 10.2334H3.5C2.67157 10.2334 2 10.905 2 11.7334V13.2334C2 14.0618 2.67157 14.7334 3.5 14.7334Z"
        stroke="#040028"
        strokeWidth="0.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
